<template>
    <div class="no-connected-numbers">
        <div class="info">
            <h2 class="h2">{{ $t("page.integration.no_integrations.title") }}
            </h2>
            <p class="p">{{ $t("page.integration.no_integrations.info") }}</p>
        </div>
        <img
            class='hero_image'
            src="@/assets/images/hero_crm-square.png"
        />
    </div>
</template>

<style scoped lang="scss">
.no-connected-numbers {
    padding-top: 20px;

    font-size: 16px;
    font-family: "Gilroy";
    font-weight: 500;
    color: #000000;

    .info {
        display: flex;
        flex-direction: column;
        align-self: flex-start;
        width: fit-content;

        .h2 {
            font-size: 160%;
        }

        .h2,
        .p {
            padding-bottom: 30px;
        }
    }


}

.hero_image {
    margin: 0 auto;
    width: 100%;
    object-fit: contain;
    max-height: calc(100vh - 250px)
}


@media screen and (max-height: 900px) {
    .hero_image {
        max-height: 900px;
    }
}

@media screen and (max-width: 1440px) {
    .hero_image {
        // max-width: 650px;
    }

    @media screen and (min-height: 900px) {
        .hero_image {
            width: 100%;
            height: fit-content;
        }
    }

}
</style>
